import request from "./common";

const prefix = "public/user";
export const publicUserAPI = {
    forgotPassword: (userEmail: string) => {
        const payload = {
            email: userEmail,
        };
        return request(`${prefix}/password/forgot`, "POST", payload);
    },
    resetPassword: (token: string, password: string) => {
        const payload = {
            token,
            newPassword: password,
        };
        return request(`${prefix}/password/reset`, "POST", payload);
    },
    setupPassword: (
        userId: string,
        password: string,
    ): Promise<SetupPasswordResponse> => {
        const payload = {
            userId,
            password,
        };
        return request(`${prefix}/password/set-up`, "POST", payload);
    },
    forgotOTP: (userEmail: string) => {
        if (!!userEmail) {
            const payload = {
                email: userEmail,
            };
            return request(`${prefix}/otp/forgot`, "POST", payload);
        }
    },
    resetOTP: (token: string) => {
        if (!!token) {
            const payload = {
                token: token,
            };
            return request(`${prefix}/otp/reset`, "POST", payload);
        }
    },
    agreeCheck: (userId: string): Promise<Boolean> => {
        const payload = {
            userId,
        };
        return request(`${prefix}/agree/check`, "POST", payload);
    },
    agreeSign: (userId: string) => {
        const payload = {
            userId,
        };
        return request(`${prefix}/agree/sign`, "POST", payload);
    },
};

export type SetupPasswordResponse = {
    email: string;
};
